import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle, ShieldCheck, WarningCircle } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Disiscrizione() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/public/disiscrivi/${token}`)
      .then(async (r) => {
        if (!r.ok) throw new Error();
        setInfo(await r.json());
      })
      .catch(() => setError(true));
  }, [token]);

  const conferma = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/public/disiscrivi/${token}`, { method: "POST" });
      if (!r.ok) throw new Error();
      setDone(true);
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="unsub-page">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-xl p-8 text-center">
        {done ? (
          <>
            <CheckCircle size={44} weight="fill" className="text-emerald-500 mx-auto" />
            <h1 className="font-display text-xl font-bold text-zinc-900 mt-4" data-testid="unsub-done">Disiscrizione completata</h1>
            <p className="text-sm text-zinc-500 mt-2">
              Non riceverai più comunicazioni di marketing{info?.nome ? `, ${info.nome}` : ""}.
              Potrai sempre dare di nuovo il consenso dal ristorante.
            </p>
          </>
        ) : error ? (
          <>
            <WarningCircle size={44} weight="fill" className="text-rose-400 mx-auto" />
            <h1 className="font-display text-xl font-bold text-zinc-900 mt-4">Link non valido</h1>
            <p className="text-sm text-zinc-500 mt-2">Il link di disiscrizione non è valido o è scaduto.</p>
          </>
        ) : info ? (
          <>
            <ShieldCheck size={44} weight="fill" className="text-zinc-700 mx-auto" />
            <h1 className="font-display text-xl font-bold text-zinc-900 mt-4">Disiscrizione dal marketing</h1>
            {info.gia_disiscritto ? (
              <p className="text-sm text-zinc-500 mt-2" data-testid="unsub-already">Risulti già disiscritto: non ricevi comunicazioni di marketing.</p>
            ) : (
              <>
                <p className="text-sm text-zinc-500 mt-2">
                  {info.nome ? <><strong className="text-zinc-800">{info.nome}</strong>, vuoi </> : "Vuoi "}
                  davvero smettere di ricevere comunicazioni promozionali?
                </p>
                <button onClick={conferma} disabled={busy} data-testid="unsub-confirm"
                  className="mt-5 w-full h-11 rounded-md bg-zinc-900 text-white text-sm font-bold hover:bg-zinc-700 active:scale-95 transition disabled:opacity-50">
                  {busy ? "Un momento..." : "Sì, disiscrivimi"}
                </button>
              </>
            )}
          </>
        ) : (
          <p className="text-sm text-zinc-400">Caricamento...</p>
        )}
        <p className="text-[10px] text-zinc-300 mt-6">
          <Link to="/privacy" className="underline">Privacy Policy</Link> · Dishenda
        </p>
      </div>
    </div>
  );
}
